module.exports = __webpack_public_path__ + "media/blink1.c886dc42.webm";